import React from 'react';
import { Weights, OpportunityScore } from '@/types/opportunity';
import SaveAssessmentButton from './SaveAssessmentButton';
import ShareAssessmentButton from './ShareAssessmentButton';
import { Button } from '@/components/shared/button';
import { ArrowLeft } from 'lucide-react';

interface AssessmentActionButtonsProps {
  weights: Weights;
  scoredOpportunities: OpportunityScore[];
  onBack: () => void;
}

const AssessmentActionButtons = ({ 
  weights, 
  scoredOpportunities,
  onBack
}: AssessmentActionButtonsProps) => {
  return (
    <div className="flex justify-between items-center w-full">
      <Button
        variant="outline"
        onClick={onBack}
      >
        <ArrowLeft className="mr-2 h-4 w-4" />
        Back
      </Button>
      <div className="flex gap-4">
        <SaveAssessmentButton 
          weights={weights}
          scoredOpportunities={scoredOpportunities}
        />
        <ShareAssessmentButton 
          weights={weights}
          scoredOpportunities={scoredOpportunities}
        />
      </div>
    </div>
  );
};

export default AssessmentActionButtons;